export const errorLogger = async (
  _uid: string,
  _organization: string,
  _site: string,
  _reportKey: string,
  _error: Error,
  _component: string
) => {
  // Firebase error logging removed — errors are tracked via Sentry
};
